export * from './Tooltip';
export * from './model';
export * from './InternalTooltip/InternalTooltip';
export { TooltipPosition } from '@microsoft/fast-foundation';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonInternalTooltip } from './InternalTooltip/InternalTooltip.definition';
provideChameleonDesignSystem().register(chameleonInternalTooltip());
